import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/szechenyi_plus_eu.webp")